import React, { useState } from 'react';
import { Box } from '@mui/material';
import _ from 'lodash';
import { FormInputSelect } from '../../../../components/form';

export function SelectFieldSetting({ settings, itemConfiguration, setItemConfiguration }: any) {
  const [value, setValue] = useState(_.get(itemConfiguration, settings.configurationKey, settings?.defaultValue ?? ''));

  const updateValue = (value: any) => {
    setValue(value);
    setItemConfiguration((prevItemConfiguration: any) => {
      return {
        ...prevItemConfiguration,
        [settings.configurationKey]: value,
      };
    });
  };

  return (
    <Box>
      <FormInputSelect
        label={settings?.selectLabel}
        helperText={settings?.helperText}
        value={value}
        onChange={updateValue}
        variant={settings?.variant ?? 'standard'}
        options={settings.options ?? []}
      />
    </Box>
  );
}
